import { ReportEmpty, ReportError, ReportLoading } from '@/features/reports/components/ChartCard';

/**
 * Generic report table.
 *
 * `columns` is a list of `{ key, header, render?, align?, width?, className? }`.
 * A row may return `null` from `render` to fall back to the raw value, which
 * keeps simple tables terse.
 */
export default function ReportTable({
    columns,
    rows = [],
    rowKey = (row, index) => row.id ?? index,
    isLoading = false,
    isError = false,
    error = null,
    emptyLabel = 'داده‌ای برای این بازه وجود ندارد',
    maxHeight,
    className = '',
    footer = null,
}) {
    if (isLoading) return <ReportLoading />;
    if (isError) return <ReportError error={error} />;
    if (!rows.length) return <ReportEmpty label={emptyLabel} />;

    return (
        <div className={`report-table-wrap ${className}`.trim()} style={maxHeight ? { maxHeight } : undefined}>
            <table className="admin-table report-table">
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th
                                key={column.key}
                                style={{
                                    textAlign: column.align ?? 'right',
                                    width: column.width,
                                }}
                            >
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={rowKey(row, index)}>
                            {columns.map((column) => (
                                <td
                                    key={column.key}
                                    style={{ textAlign: column.align ?? 'right' }}
                                    className={column.className}
                                >
                                    {column.render ? column.render(row, index) : row[column.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
                {footer && <tfoot>{footer}</tfoot>}
            </table>
        </div>
    );
}
